import { render, staticRenderFns } from "./banks.vue?vue&type=template&id=83f75e22&scoped=true&"
import script from "./banks.vue?vue&type=script&lang=js&"
export * from "./banks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f75e22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83f75e22')) {
      api.createRecord('83f75e22', component.options)
    } else {
      api.reload('83f75e22', component.options)
    }
    module.hot.accept("./banks.vue?vue&type=template&id=83f75e22&scoped=true&", function () {
      api.rerender('83f75e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/banks.vue"
export default component.exports